import { Button, Drawer, Form, Space, Input } from "antd";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { RiFilterOffLine } from "react-icons/ri";
import { ExportToExcel } from "../../../utils/XLSXExport";
const { Search } = Input;
export default function CustomerPanel({
  setShowDetails,
  isVisible,
  customers,
}: any) {
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };
  return (
    <Drawer
      title={"Customers List"}
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by name"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border  p-1 hover:bg-green-100"
            >
              <BiExport size={24} color="#323232" />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    customers?.map((record: any, index: number) => {
                      return {
                        "S/N": index + 1,

                        Name:
                          record?.customer?.name === null
                            ? "-"
                            : record?.customer?.name,
                        Model: record?.model === null ? "-" : record?.model,
                        Address:
                          record?.customer?.address === null
                            ? "-"
                            : record?.customer?.address,
                        Email:
                          record?.customer?.email === null
                            ? "-"
                            : record?.customer?.email,
                        Mobile:
                          record?.customer?.mobile === null
                            ? "-"
                            : record?.customer?.mobile,
                      };
                    }),
                    "Customers.xlsx"
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-52 truncate font-bold">Name</div>
              <div className="w-52 truncate text-left font-bold">Address</div>
              <div className="w-36 truncate font-bold">Email</div>
            </div>
            <div className="font-bold">Mobile</div>
          </div>
        </div>
        {customers
          ?.filter((customer: any) =>
            customer?.customer?.name?.includes(search)
          )
          ?.map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-52">
                    {item?.customer?.name === null ? "-" : item?.customer?.name}
                  </div>
                  <div className="w-52 truncate ">
                    {item?.customer?.address === null
                      ? "-"
                      : item?.customer?.address}
                  </div>
                  <div className="w-36 truncate">
                    {item?.customer?.email === null
                      ? "-"
                      : item?.customer?.email}
                  </div>
                </div>
                <div className="hover:text-toyota cursor-pointer">
                  {item?.phone === null ? "-" : "-"}
                </div>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="ml-2">Total Customers</div>
          <div className="font-bold">
            {
              customers?.filter((customer: any) =>
                customer?.customer?.name?.includes(search)
              ).length
            }
          </div>
        </div>
      </div>
    </Drawer>
  );
}
